import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
 
const routes: Routes = [
    {
      path: '', loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule) //dashboards
    },
 
    {
      path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule) //checkout
    },
    {
      path: 'requisitions', loadChildren: () => import('./requisitions/requisitions.module').then(m => m.RequisitionsModule) //requisitions
    },
 
    {
      path: 'contacts', loadChildren: () => import('./contacts/crm.module').then(m => m.CrmModule) //contacts
    },
 
    {
      path: 'clients', loadChildren: () => import('./clients/clients.module').then(m => m.ClientsModule) //clients
    },
    {
      path: 'users', loadChildren: () => import('./users/userPage.module').then(m => m.UserPageModule) //users
    },

    {
      path: 'pages', loadChildren: () => import('./extrapages/extraspages.module').then(m => m.ExtraspagesModule) //most of everything
    },
    {
      path: 'marketplace', loadChildren: () => import('./nft-marketplace/nft-marketplace.module').then(m => m.NftMarketplaceModule) //marketplace and Explore
    },
    {
      path: 'invoice',  loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule) //invoice and billing
    },
    {
      path: 'operations',  loadChildren: () => import('./operations/operations.module').then(m => m.OperationsModule) //notifications and Import management
    }
];
 
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
 